/* Hoe de pagina zich gedraagt terwijl je scrollt en sleept.

   Bewust los van earthle.js gehouden. Dat bestand tekent de reis en bouwt de
   keuzehulp; dit gaat alleen over beweging. Zo is duidelijk waar je moet zijn
   als er iets aan het gedrag moet veranderen.
*/

/* ---------------- een voor een in beeld ------------------------------------
   Een rij met data-instroom krijgt de klasse aan zodra hij in beeld komt, en
   houdt die daarna. We kijken maar een keer, dus terugscrollen draait niets
   terug: dat is precies waar animaties op een winkelpagina irritant worden.

   Het ritme staat in de opmaak van de sectie zelf, niet hier. Zo kan het ene
   rooster sneller binnenlopen dan het andere zonder dat dit bestand daar iets
   van hoeft te weten.

   De kaarten staan alleen verborgen als er javascript is: de html krijgt in de
   head al de klasse js, en de opmaak hangt daaraan. Valt javascript weg, dan
   zie je gewoon alles staan.
*/
(function(){
  var rijen = [].slice.call(document.querySelectorAll('[data-instroom]'));
  if(!rijen.length) return;

  var stil = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
          || document.body.getAttribute('data-disable-animations') === 'true';

  if(stil || !('IntersectionObserver' in window)){
    rijen.forEach(function(rij){ rij.classList.add('meteen', 'aan'); });
    return;
  }

  /* Naast de waarnemer hangt een vangnet dat zelf meet en zich daarna afhaakt.
     Dat is geen overdaad: een waarnemer vuurt niet op een pagina die niet
     getekend wordt, bijvoorbeeld in een tabblad op de achtergrond of in een
     ingesloten voorbeeldweergave. Zonder vangnet blijft de rij dan voorgoed
     onzichtbaar, en een lege pagina is erger dan een pagina zonder animatie. */
  function vangnet(rij){
    function kijk(){
      if(rij.classList.contains('aan')){ afhaken(); return; }
      var vak = rij.getBoundingClientRect();
      if(vak.top < (window.innerHeight || 0) && vak.bottom > 0){
        rij.classList.add('aan');
        afhaken();
      }
    }
    function afhaken(){
      removeEventListener('scroll', kijk);
      removeEventListener('resize', kijk);
    }
    addEventListener('scroll', kijk, {passive:true});
    addEventListener('resize', kijk);
    setTimeout(kijk, 1200);
  }

  var kijker = new IntersectionObserver(function(regels){
    regels.forEach(function(regel){
      if(!regel.isIntersecting) return;
      regel.target.classList.add('aan');
      kijker.unobserve(regel.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  rijen.forEach(function(rij){
    kijker.observe(rij);
    vangnet(rij);
  });
})();

/* ---------------- beoordelingen slepen -------------------------------------
   De pijlen naast de kop worden in earthle.js afgehandeld. Dit is alleen het
   slepen met de muis, want met een muis is er verder geen manier om de rij te
   verschuiven dan die twee pijlen.

   Pas grijpen na vijf pixels beweging. Anders kun je geen tekst meer
   selecteren in een citaat, en dat is nu juist wat mensen doen als ze een
   beoordeling willen overnemen. Aanraakschermen laten we met rust: die
   scrollen zo'n rij vanzelf al.
*/
(function(){
  [].slice.call(document.querySelectorAll('[data-rev-rail]')).forEach(function(rail){
    var neer = false, grijpt = false, startX = 0, startLinks = 0, pid = null;

    rail.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'touch' || e.button !== 0) return;
      neer = true;
      grijpt = false;
      startX = e.clientX;
      startLinks = rail.scrollLeft;
      pid = e.pointerId;
    });

    rail.addEventListener('pointermove', function(e){
      if(!neer) return;
      var weg = e.clientX - startX;
      if(!grijpt){
        if(Math.abs(weg) < 5) return;
        grijpt = true;
        rail.classList.add('sleept');
        try { rail.setPointerCapture(pid); } catch(err){}
      }
      e.preventDefault();
      rail.scrollLeft = startLinks - weg;
    });

    function los(){
      if(grijpt){
        rail.classList.remove('sleept');
        try { rail.releasePointerCapture(pid); } catch(err){}
      }
      neer = false;
      grijpt = false;
    }

    /* Loslaten buiten de rij hoort ook te tellen, anders blijft hij plakken. */
    rail.addEventListener('pointerup', los);
    rail.addEventListener('pointercancel', los);
    addEventListener('pointerup', los);

    rail.addEventListener('dragstart', function(e){ if(grijpt) e.preventDefault(); });
  });
})();
